/**
 * メールアドレスの書式
 */
export const isEemail = (value) => {
  // Let's not start a debate on eemail regex. This is just for an example app!
  if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    return true;
  } else {
    return false;
  }
};

/**
 * 半角英数字のみ
 */
export const isHalfSizeAlphabet = (value) => {
  if (/^[0-9a-zA-Z]+$/.test(value)) {
    return true;
  } else {
    return false;
  }
};

/**
 * 半角英数字(+アンダースコア) のみ
 */
export const isHalfSizeAlphabetWithUnderscore = (value) => {
  if (/^[0-9a-zA-Z_]+$/.test(value)) {
    return true;
  } else {
    return false;
  }
};

/**
 * 空文字
 */
export const isBlank = (value) => {
  if (value && value.trim().length) {
    return false;
  } else {
    return true;
  }
};

/**
 * 最大文字数
 */
export const withinMinLength = (min) => {
  return value => {
    if (value.length < min) {
      return false;
    } else {
      return true;
    }
  };
};

/**
 * 最低文字数
 */
export const withinMaxLength = (max) => {
  return value => {
    if (value.length > max) {
      return false;
    } else {
      return true;
    }
  };
};

/**
 * 数値のみ
 */
export const isInteger = (value) => {
  if (Number.isInteger(Number(value))) {
    return true;
  } else {
    return false;
  }
};

/**
 * 郵便番号
 */
export const isPostalCode = (value) => {
  if (/^\d{3}[-]\d{4}$/.test(value)) {
    return true;
  } else {
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/js/modules/validation.js